module.exports = __webpack_public_path__ + "img/project-9.d54e75bc.jpg";